// extracted by mini-css-extract-plugin
export default {"container":"BottomLead_container__FZOqR","text":"BottomLead_text__xtZ7o","form":"BottomLead_form__ysh4v"};